import React from 'react';
import {handleModalState} from '@pluto/utils';
import ConfirmDialog from '@pluto/delete-dialog/DeleteDialog';
import {HandleQCArtwork} from '../QCToolsArtworkTypes&Const';

export const handleRetryArtwork = ({
    id,
    qcId,
    setArtworksWait,
    retryArtwork,
    dispatch,
}: HandleQCArtwork) => () => {
    dispatch(
        retryArtwork({
            id,
            qcId,
        })
    );
    dispatch(setArtworksWait(id));
};

export const handleDeleteArtwork = ({
    id,
    qcId,
    setArtworksWait,
    deleteArtwork,
    dispatch,
    setModalVisible,
}: HandleQCArtwork) => () => {
    dispatch(
        deleteArtwork({
            id,
            qcId,
        })
    );
    dispatch(setArtworksWait(id));
    setModalVisible(false);
};

export const getDeleteConfirmationDialog = (
    modalVisible: boolean,
    setModalVisible: (value: boolean) => void,
    confirmDeleteArtwork: () => void
) => {
    return modalVisible ? (
        <ConfirmDialog
            onClose={handleModalState(setModalVisible, false)}
            onConfirm={confirmDeleteArtwork}
            text="Are you sure you want to delete?"
            secondaryText="This action cannot be undone!"
            cancelText="No"
            confirmText="Yes"
            additionalClassName="delivery-job-popup"
        />
    ) : null;
};
